import { bindActionCreators } from 'redux';
import { fetchAllAuditLogs } from '../../../redux/members/actions';

const map = (dispatch) => ({
  ...bindActionCreators(
    {
      fetchAllAuditLogs,
    },
    dispatch,
  ),
});

export default map;
